import { createFileRoute } from "@tanstack/react-router";
import { SiteHeaderEn } from "@/components/SiteHeaderEn";
import { SiteFooterEn } from "@/components/SiteFooterEn";
import { RoiCalculator } from "@/components/RoiCalculator";
import { LeadSection } from "@/components/LeadSection";

const SITE = "https://shopify-freelancer.net";
const TITLE = "Shopify Conversion Calculator: Revenue Impact";
const DESCRIPTION =
  "Calculate what a higher Shopify conversion rate is worth: added revenue per month and year, payback time and return on the project fee.";

export const Route = createFileRoute("/en/roi-calculator")({
  component: CalculatorEn,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}/en/roi-calculator` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: `${SITE}/en/roi-calculator` },
      { rel: "alternate", hrefLang: "de", href: "https://shopify-freelancer.net/roi-rechner" },
      { rel: "alternate", hrefLang: "en", href: "https://shopify-freelancer.net/en/roi-calculator" },
      { rel: "alternate", hrefLang: "x-default", href: "https://shopify-freelancer.net/roi-rechner" },
      { rel: "alternate", hrefLang: "de", href: `${SITE}/roi-rechner` },
      { rel: "alternate", hrefLang: "en", href: `${SITE}/en/roi-calculator` },
    ],
  }),
});

function CalculatorEn() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeaderEn />
      <main>
        <section className="veil border-b border-border/60 py-16 md:py-20">
          <div className="mx-auto max-w-6xl px-5">
            <p className="font-mono text-[11px] uppercase tracking-[0.34em] text-primary">
              Calculator
            </p>
            <h1 className="mt-5 max-w-3xl text-4xl font-bold leading-[1.08] md:text-5xl">
              What is one point of <span className="text-signal">conversion rate</span> worth?
            </h1>
            <p className="mt-5 max-w-xl text-muted-foreground">
              Enter your traffic, conversion rate and average order value. You see the added
              revenue, the payback time and the return on the fee.
            </p>
          </div>
        </section>

        <section className="py-14">
          <div className="mx-auto max-w-6xl px-5">
            <RoiCalculator lang="en" />
          </div>
        </section>

        <LeadSection source="en-calculator" lang="en" />
      </main>
      <SiteFooterEn />
    </div>
  );
}
